<template>
    <main-layout>
        <div class="page-head" slot="header">
            <div><div class="page-kicker">Notices &amp; forms</div><h2>Create rent increases</h2></div>
        </div>

        <section class="page-section">
            <el-form :inline="true" size="medium" width="400px">
                <el-form-item label="Start Date">
                    <el-date-picker
                        v-model="start_date_range"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="End Date">
                    <el-date-picker
                        v-model="end_date_range"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        placeholder="">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="Unit">
                    <el-input v-model="params.unit_address" placeholder="" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :loading="loading" @click="onSearch">Filter</el-button>
                </el-form-item>
            </el-form>
        </section>

        <section class="page-section" v-loading="loading">
            <el-table :data="dataList" @selection-change="onSelectionChange">
                <el-table-column width="45" type="selection"/>
                <el-table-column label="Property ID" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.unit.property?.custom_id }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="unit.formatted_address" label="Unit Address"/>
                <el-table-column prop="StartDate" label="Start Date" width="150"/>
                <el-table-column prop="EndDate" label="End Date" width="150"/>
                <el-table-column prop="TotalAmount" label="Total Amount" width="120"/>
                <el-table-column prop="RentCycle" label="Rent Cycle" width="120"/>
            </el-table>
            <div class="table-edit-footer">
                <div class="table-actions">
                    <el-select size="small" placeholder="Bulk Actions" v-model="bulkAction">
                        <el-option value="delete" label="Delete"/>
                        <el-option value="send" label="Generate Report"/>
                    </el-select>
                    <el-button size="small" type="primary" :disabled="!selectionIds.length||!bulkAction"
                               @click="onBatchOperation">
                        Apply Selected
                    </el-button>
                    <el-button size="small" type="primary" @click="onApplyAll" :disabled="bulkAction=='delete'">
                        Apply All
                    </el-button>
                </div>
                <el-pagination
                    background
                    layout="prev, pager, next, total"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="page"
                    @current-change="onPageChange"
                />
            </div>
        </section>
        <dialog-rent-increase-settings ref="settings"/>
    </main-layout>
</template>

<script>
import Pagination from "../mixins/Pagination";
import DialogRentIncreaseSettings from "./DialogRentIncreaseSettings.vue";

export default {
    name: "LeaseRents",
    components: {DialogRentIncreaseSettings},
    mixins: [Pagination],
    data() {
        return {
            params: {
                unit_address: ''
            },
            bulkAction: '',
            showSettings: false,
            start_date_range: [],
            end_date_range: []
        }
    },
    methods: {
        listApi() {
            return '/buildium/leases/schedules'
        },
        listParams() {
            return {
                ...this.params,
                start_date_range: this.start_date_range.join('-'),
                end_date_range: this.end_date_range.join('-'),
            };
        },
        batchDelete() {
            this.$confirm(this.$t('common.delete_tips'), this.$t('common.delete_confirm'), {
                type: 'warning'
            }).then(() => {
                let ids = this.selectionIds.map(item => item.Id);
                this.loading = true;
                this.$api.delete('/buildium/leases/schedules/batch', {data: {ids}}).then(response => {
                    this.$message.success('Deleted successfully');
                    this.fetchList();
                }).catch(reason => {
                    this.$message.error(reason.message);
                });
            }).catch(() => {
                this.$message.info('Canceled');
            });
        },
        onBatchOperation() {
            let {bulkAction} = this;
            if (bulkAction === 'delete') {
                this.batchDelete();
            }
            if (bulkAction === 'send') {
                this.$refs.settings.open((options) => {
                    let ids = this.selectionIds.map(item => item.Id);
                    this.generateReports(options, {ids});
                });
            }
        },
        onApplyAll() {
            this.$refs.settings.open((options) => {
                this.generateReports(options, this.listParams());
            });
        },
        generateReports(options, params) {
            this.loading = true;
            this.$api.post('/buildium/leases/schedules/generate-report', {
                ...params,
                options
            }).then(response => {
                const d = response.data || {};
                const parks = d.skipped_parks || [];
                if (parks.length) {
                    this.$alert(`${d.queued || 0} notice(s) queued. ${parks.length} lease(s) in manufactured home parks were left out — they use a different notice and must be prepared separately:\n` + parks.slice(0, 20).join('\n') + (parks.length > 20 ? `\n…and ${parks.length - 20} more` : ''),
                        'Parks left out', {confirmButtonText: 'OK'});
                } else {
                    this.$message.success(`${d.queued !== undefined ? d.queued + ' notice(s)' : 'Notices'} added to the queue`);
                }
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
    },
    mounted() {
        this.fetchList();
    }
}
</script>

<style scoped>

</style>